"use client";

import { Alert, Box, Slide, Stack } from "@mui/material";
import { createContext, useCallback, useContext, useState } from "react";

const ToastContext = createContext();

let idCounter = 0;

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const showToast = useCallback(
    (message, severity = "info", duration = 6000) => {
      const id = idCounter++;
      const newToast = { id, message, severity };

      setToasts((prev) => [...prev, newToast]);

      setTimeout(() => {
        setToasts((prev) => prev.filter((toast) => toast.id !== id));
      }, duration);
    },
    []
  );

  const hideToast = useCallback((id) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  }, []);

  return (
    <ToastContext.Provider value={{ showToast }}>
      {children}

      <Box
        sx={{
          position: "fixed",
          top: 76,
          right: 16,
          zIndex: 1400,
          width: "auto",
        }}
      >
        <Stack spacing={1}>
          {toasts.map((toast) => (
            <Slide
              key={toast.id}
              in
              direction="left"
              mountOnEnter
              unmountOnExit
            >
              <Alert
                severity={toast.severity}
                onClose={() => hideToast(toast.id)}
                // variant="filled"
              >
                {toast.message}
              </Alert>
            </Slide>
          ))}
        </Stack>
      </Box>
    </ToastContext.Provider>
  );
};

export const useToast = () => useContext(ToastContext);
